// Customised by Artie on 13/10/25 to add custom plaque message functionality
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      
      // Store the plaque variant ID
      this.plaqueVariantId = '45830131286236';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';

      const formData = new FormData(this.form);

      // Collect all line item properties from the form (including Alcohol Free)
      const baseProperties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value != null && String(value).trim() !== '') {
          const propName = match[1]; // e.g. "Alcohol Free"
          baseProperties[propName] = value;
        }
      }

      // Plaque message comes from the same pool of properties
      const plaqueMessage = baseProperties['Plaque message'];
      const hasPlaqueMessage = plaqueMessage && plaqueMessage.trim() !== '';
      
      // Get the parent product variant ID
      const parentVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);

      // Shared ID to link parent and child line items
      const plaqueLinkId = Date.now().toString();
      
      // Build the cart add request
      let cartAddBody;

      if (hasPlaqueMessage) {
        // Parent line item gets all base properties (including Alcohol Free) + plaque flags
        const parentProperties = {
          ...baseProperties,
          _plaque_parent: 'true',
          _plaque_id: plaqueLinkId
        };

        cartAddBody = {
          items: [
            {
              id: parentVariantId,
              quantity,
              properties: parentProperties
            },
            {
              id: this.plaqueVariantId,
              quantity: 1,
              properties: {
                _plaque_child: 'true',
                _plaque_parent_id: parentVariantId,
                _plaque_id: plaqueLinkId,
                _plaque_message_text: plaqueMessage
              }
            }
          ]
        };
      } else {
        // No plaque product, but still pass any other properties (e.g. Alcohol Free)
        const parentItem = {
          id: parentVariantId,
          quantity
        };

        if (Object.keys(baseProperties).length > 0) {
          parentItem.properties = baseProperties;
        }

        cartAddBody = {
          items: [parentItem]
        };
      }
      
      // Add sections for cart update
      if (this.cart) {
        cartAddBody.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        cartAddBody.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = JSON.stringify(cartAddBody);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form', 
              productVariantId: parentVariantId, 
              errors: response.description, 
              message: response.message
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form', 
              productVariantId: parentVariantId
            });
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}